<!--
 * @Description: 验证码登录、密码登录
 * @Date: 2021-11-10 13:44:01
-->
<template>
  <div class="user-login__item user-login__register">
    <div class="user-login__sec">账号注册</div>
    <LoginForm
      ref="formRef"
      :formData="formData"
      :itemList="itemList"
      :pageType="LoginTypeEnum.REGISTER"
    ></LoginForm>
    <div class="user-login__register-foot">
      <base-button :click="onLogin" class="user-login__register-btn">
        立即注册
      </base-button>
      <p class="user-login__register-change">
        已有账号，
        <span style="color: var(--xrk-color-primary)" @click="onMain">
          登录
        </span>
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { BaseButton } from 'xrk-components';

import { LoginForm } from './login-base/index';
import type { FormRef } from '../types/index';
import { LoginTypeEnum, FormItemEnum } from '../constants/index';

import { phoneRegistration } from '../data-source/apis';

import { useSetup } from '../store';

const store = useSetup();

const formData = ref({ agreement: store.loginData.agreement });
const itemList = [FormItemEnum.phone, FormItemEnum.agreement];
const model = defineModel();
const forgetThePassword = 1;
// 表单实例
const formRef = ref<FormRef>(null);

const onMain = () => {
  store.setLoginData({
    ...store.loginData,
    agreement: formRef.value.data.agreement
  });
  model.value = 'login-main';
};

const onLogin = async () => {
  await formRef.value.validate();
  const { data } = await phoneRegistration({
    [FormItemEnum.phone]: formRef.value.data[FormItemEnum.phone],
    [FormItemEnum.code]: formRef.value.data[FormItemEnum.code],
    forgetThePassword
  });
  // 仅同步信息
  store.setInfo(data);
  model.value = 'login-setpwd';
};
</script>

<style scoped lang="scss">
.user-login__register {
  .user-login__register-foot {
    height: 70px;
    .user-login__register-btn {
      width: 368px;
      height: 40px;
      border-radius: 2px 2px 2px 2px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      cursor: pointer;
    }
    .user-login__register-change {
      width: 100%;
      height: 22px;
      text-align: right;
      font-size: 14px;
      color: #1a1a1a;
      line-height: 22px;
      margin-top: 16px;
      > span {
        cursor: pointer;
      }
    }
  }
}
</style>
